import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  Avatar,
  Box,
  DialogActions,
  List,
  ListItemAvatar,
  ListItemText,
  ListItem,
  Slide,
  Typography,
  TextField,
  FormControl,
  Autocomplete,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  useTheme,
  ListItemIcon,
} from "@mui/material";
import { UserContext } from "../../context";

import {
  getCustomInterests,
  getInterestsAreas,
  updateProfileInstance,
} from "../../services/FeedApi";
import {
  addCustomInterest,
  addOrUpdateInterests,
  getAnswer,
  getPeopleYouMayKnow,
  sendConnectionRequest,
  followOrganization,
} from "../../services/UserProfileApi";
import SkeletonAnimation from "../SkeletonAnimation";
import { getImageUrlWithToken } from "../../utils/ImageUtils";
import ProfilePictureSetting from "../ProfilePictureSetting";
import { Add, CheckCircleOutline, Close } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Describe from "../Describe";
import { joinWaitlist } from "../../services/Festivals";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InterestsDialog = ({ open, setOpen, onAllDone, showSnackbar }) => {
  const theme = useTheme();
  
  // Restore step from localStorage if exists
  const [step, setStep] = useState(() => {
    const savedStep = localStorage.getItem('onboarding_step');
    return savedStep ? parseInt(savedStep, 10) : 1;
  });
  
  const [selectedInterests, setSelectedInterests] = useState({});
  const [interestlist, setInterestlist] = useState([]);
  const [isFetchingList, setIsFetchingList] = useState(true);
  const [suggestedPeople, setSuggestedPeople] = useState([]);
  const [isFetchingPeople, setIsFetchingPeople] = useState(true);
  const [expandedArea, setExpandedArea] = useState(null);
  const [followedPeople, setFollowedPeople] = useState([]);
  const [customInterest, setCustomInterest] = useState("");
  const [customInterestsList, setCustomInterestsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userCustomInterests, setUserCustomInterests] = useState([]);


  const handleInterestChange = (areaId, interest) => {
    setSelectedInterests((prev) => {
      const areaInterests = prev[areaId] || [];
      const exists = areaInterests.some((item) => item.id === interest.id);

      return {
        ...prev,
        [areaId]: exists
          ? areaInterests.filter((item) => item.id !== interest.id)
          : [...areaInterests, interest],
      };
    });
  };

  const handleAccordionChange = (areaId) => {
    setExpandedArea(expandedArea === areaId ? null : areaId);
  };

  const [changeBtnText, setChangeBtnText] = useState("Skip");

  const handleFollowToggle = (personId, accountType) => {
    setFollowedPeople((prev) => {
      if (prev.includes(personId)) {
        return prev.filter((id) => id !== personId);
      }
      return [...prev, personId];
    });

    if (accountType === "organization") {
      followOrganization(personId)
        .then((data) => {
          console.log("Organization followed:", data);
          setChangeBtnText("Done");
        })
        .catch((error) => {
          console.log("Error following organization:", error);
        });
    } else {
      sendConnectionRequest(personId)
        .then((data) => {
          console.log("Connection request sent:", data);
          setChangeBtnText("Done");
        })
        .catch((error) => {
          console.log("Error sending connection request:", error);
        });
    }
  };

  const { user } = useContext(UserContext);
  //console.log("User", user);

  // Save step to localStorage whenever it changes
  useEffect(() => {
    if (step > 1) {
      localStorage.setItem('onboarding_step', step.toString());
    }
  }, [step]);

  //get interests from the api , if user is logged in
  const fetchInterestList = () => {
    if (user?.status === 2 && user?.account_type !== "unknown") {
      setIsFetchingList(true);
      getInterestsAreas()
        .then((data) => {
          console.log("Interest Areas", data);
          setInterestlist(data);
          // setExpandedArea(data[0]?.id);
          setIsFetchingList(false);
        })
        .catch((error) => {
          console.log(error);
          setIsFetchingList(false);
        });
    }
  };

  const getPeople = () => {
    setIsFetchingPeople(true);
    getPeopleYouMayKnow()
      .then((data) => {
        console.log("People you may know", data);
        setIsFetchingPeople(false);
        setSuggestedPeople(data);
      })
      .catch((error) => {
        console.log(error);
        setIsFetchingPeople(false);
      });
  };

  // Fetch people you may know if user and step is 4 and individual account
  // Skip if user came from festival submissions (they get waitlist instead)
  useEffect(() => {
    const fromFestivalSubmissions = localStorage.getItem('fromFestivalSubmissions');
    if (step === 4 && user?.account_type === "individual" && fromFestivalSubmissions !== 'true') {
      getPeople();
    }
  }, [step, user?.account_type]);

  useEffect(() => {
    fetchInterestList();
    fetchAnswers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleUpdateInterests = () => {
    const interests = Object.values(selectedInterests).flat();
    const interestIds = interests.map((interest) => interest.id);
    addOrUpdateInterests(interestIds)
      .then((data) => {
        console.log(data);
        setStep(4);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleJoinWaitlist = () => {
    joinWaitlist()
      .then((data) => {
        // Clear festival listing and submissions flags after completing onboarding
        console.log("Joined waitlist:", data);
        showSnackbar(data.message, "success");
        localStorage.removeItem('fromFestivalListing');
        localStorage.removeItem('fromFestivalSubmissions');
        localStorage.removeItem('onboarding_step');
        // Close dialog after logging
        setOpen(false);
        onAllDone();
      })
      .catch((error) => {
        console.log("Error joining waitlist:", error);
      });
  };

  const [answer, setAnswer] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState([]);

  const [describesMe, setDescribesMe] = useState("");
  const handleChangeDescribeMe = (value) => {
    setDescribesMe(value);
  };

  // Auto-select "Film Festival / Event Organizer" if user came from festival listing button
  useEffect(() => {
    const fromFestivalListing = localStorage.getItem('fromFestivalListing');
    if (fromFestivalListing === 'true' && user?.account_type === 'organization') {
      setDescribesMe('Film Festival / Event Organizer');
      // Don't clear the flag here - will clear when user completes onboarding
    }
  }, [user?.account_type]);

  const [popupOpen, setPopupOpen] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (customInterest.trim().length >= 3) {
        setIsLoading(true);
        getCustomInterests(customInterest)
          .then((response) => {
            const interests = response.map((item) => item.interest_name);
            setCustomInterestsList(interests);
          })
          .catch((error) => {
            console.error("Error fetching custom interests: ", error);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setCustomInterestsList([]); // Clear suggestions if less than 3 chars
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(delayDebounceFn);
  }, [customInterest]);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleAddCustomInterest = () => {
    const data = {
      add_interest: customInterest,
    };

    addCustomInterest(data)
      .then((response) => {
        console.log("Custom interest added: ", response);
        setUserCustomInterests([
          ...userCustomInterests,
          { interest_name: response.added_interest, interest_image: "null" },
        ]);
        setCustomInterest("");
        setSuccess(response.message);
        setTimeout(() => {
          setSuccess(null);
        }, 3000);
      })
      .catch((error) => {
        console.error("Error adding custom interest: ", error);
        setError(error.error);
      });
  };

  const handleDeleteCustomInterest = (interestName) => {
    const data = {
      delete_interest: interestName,
    };

    addCustomInterest(data)
      .then((response) => {
        console.log("Custom interest deleted: ", response);
        const updatedCustomInterests = userCustomInterests.filter(
          (customInterest) => customInterest.interest_name !== interestName
        );
        setUserCustomInterests(updatedCustomInterests);
      })
      .catch((error) => {
        console.error("Error deleting custom interest: ", error);
      });
  };

  const fetchAnswers = () => {
    if (user?.status === 2 && user?.account_type !== "unknown") {
      getAnswer()
        .then((response) => {
          const answersList = response.why_im_here.map((item) => ({
            id: item.id,
            title: item.answer,
          }));
          const uniqueAnswers = Array.from(
            new Map(answersList.map((item) => [item.title, item])).values()
          );
          setAnswer(uniqueAnswers);
        })
        .catch((error) => {
          console.error("Error fetching questions details: ", error);
        });
    }
  };

  const [userPhone, setUserPhone] = useState(user?.phone || "");
  const [errors, setErrors] = useState(null);
  // Custom Pronouns
  const [customPronoun, setCustomPronoun] = useState("");
  const handleCustomPronounChange = (event) => {
    setCustomPronoun(event.target.value);
  };

  // Pronouns
  const [pronouns, setPronouns] = useState(user?.pronouns || "");

  // Handle change for pronouns
  const handleChangePronouns = (event) => {
    const value = event.target.value;
    setPronouns(value);
  };

  const handleGetStarted = () => {
    const data = {
      describes_me: describesMe,
      answers_ids: selectedAnswers.map((item) => item.id),
      phone: userPhone,
      pronouns: pronouns === "Custom" ? customPronoun : pronouns,
    };
    updateProfileInstance(data)
      .then((data) => {
        console.log(data);
        setStep(2);
      })
      .catch((error) => {
        console.log(error);
        setErrors(error.error);
      });
  };

  const renderSelectedInterestsChips = (areaId) => {
    const selected = selectedInterests[areaId] || [];
    if (selected.length === 0) return null;

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.8,
          mt: 1,
          ml: 1,
          mb: 1,
        }}
      >
        {selected.map((interest) => (
          <Chip clickable={false}
            onClick={() => { }}
            key={interest.id}
            label={interest.interest_name}
            size="small"
            variant="outlined"
            color="grey.800"
            sx={{
              bgcolor: theme.palette.secondary.dark,
            }}
            onDelete={() => handleInterestChange(areaId, interest)}
          />
        ))}
      </Box>
    );
  };


  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="dialog-title"
      role="dialog"
      aria-hidden={!open}
    >
      <DialogTitle sx={{ bgcolor: "background.paper" }} id="dialog-title">
        {step === 1 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography
              variant="body1"
              sx={{ fontSize: "1.1rem", fontWeight: 500 }}
            >
              Hey{" "}
              <Box
                component="span"
                sx={{ fontWeight: 700, color: "primary.main" }}
              >
                {user?.name} 👋 <br />{" "}
              </Box>

              <Typography
                component={"span"}
                variant="body1"
                color="textSecondary"
              >
                Welcome to our community! 🎉 Let's get to know you better!
              </Typography>
            </Typography>
          </Box>
        )}
        {step === 2 && "Set profile picture"}
        {step === 3 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography variant="h6">Select your interests</Typography>
            <Typography variant="body2">Select one or more to continue</Typography>
          </Box>
        )}
        {step === 4 && user?.account_type === "individual" && (() => {
          const fromFestivalSubmissions = localStorage.getItem('fromFestivalSubmissions');
          return fromFestivalSubmissions === 'true' ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, textAlign: "center" }}>
              <Typography variant="h6">Run Your Festival Smarter. Reach Filmmakers Directly.</Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="h6">Grow your network</Typography>
              <Typography variant="body2">
                Connect with people to expand your network
              </Typography>
            </Box>
          );
        })()}
        {step === 4 && user?.account_type === "organization" && (
          <Typography variant="h6">Run Your Festival Smarter. Reach Filmmakers Directly.</Typography>
        )}
      </DialogTitle>


      <DialogContent sx={{ bgcolor: "background.paper" }}>
        {step === 1 ? (
          <>
            <TextField
              fullWidth
              margin="dense"
              label="Phone Number"
              size="small"
              value={userPhone}
              onChange={(e) =>
                setUserPhone(e.target.value.replace(/[^0-9]/g, "").slice(0, 10))
              }
              placeholder="Phone Number"
              slotProps={{
                input: {
                  maxLength: 10,
                  pattern: "[0-9]{10}",
                },
              }}
            />

            {user?.account_type !== "organization" && (
              <Autocomplete
                multiple
                id="tags-outlined"
                options={answer}
                getOptionLabel={(option) => option.title}
                filterSelectedOptions
                disableCloseOnSelect
                value={selectedAnswers}
                onChange={(event, newValue) => {
                  setSelectedAnswers(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    margin="dense"
                    variant="outlined"
                    label="I'm here for? *"
                    placeholder="Select one or more"
                    error={Boolean(errors?.answers_ids)}
                    helperText={errors?.answers_ids}
                  />
                )}
              />
            )}

            <Describe
              accountType={user?.account_type}
              error={errors}
              describesMe={describesMe}
              onDescribeMeChange={handleChangeDescribeMe}
            />

            {user?.account_type === "individual" && (
              <>
                <FormControl fullWidth margin="dense" size="small">
                  <InputLabel htmlFor="pronouns">Pronouns</InputLabel>
                  <Select
                    labelId="pronouns"
                    id="pronouns"
                    value={pronouns}
                    onChange={handleChangePronouns}
                    label="Pronouns"
                  >
                    <MenuItem value="">
                      <em>Not Specified</em>
                    </MenuItem>
                    <MenuItem value="He/Him">He/Him</MenuItem>
                    <MenuItem value="She/Her">She/Her</MenuItem>
                    <MenuItem value="They/Them">They/Them</MenuItem>
                    <MenuItem value="Custom">Custom</MenuItem>
                  </Select>
                  <FormHelperText error={Boolean(errors?.pronouns)}>
                    {errors?.pronouns}
                  </FormHelperText>
                </FormControl>

                {pronouns === "Custom" && (
                  <TextField
                    size="small"
                    placeholder="Enter Custom Pronouns"
                    value={customPronoun || ""}
                    onChange={handleCustomPronounChange}
                    fullWidth
                    margin="dense"
                  />
                )}
              </>
            )}
          </>
        ) : step === 2 ? (
          <Box sx={{ p: 2 }}>
            <ProfilePictureSetting
              setStep={setStep}
              accountType={user?.account_type}
            />
          </Box>
        ) : step === 3 ? (
          <>
            {isFetchingList
              ? [...Array(15)].map((_, index) => (
                <Box key={index} sx={{ display: "flex", mb: 2 }}>
                  <SkeletonAnimation
                    width="100%"
                    height={40}
                    animation="wave"
                    variant="rectangular"
                  />
                </Box>
              ))
              : interestlist.map((area) => (
                <React.Fragment key={area.id}>
                  <Accordion
                    // key={area.id}
                    variant="outlined"
                    // expanded={expandedArea === area.id}
                    onChange={() => handleAccordionChange(area.id)}
                    sx={{
                      mb: 2,
                      "&:before": {
                        display: "none",
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`${area.id}-content`}
                      id={`${area.id}-header`}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography>{area.interest_area_name}</Typography>
                        {selectedInterests[area.id]?.length > 0 && (
                          <Box
                            sx={{
                              ml: 1,
                              backgroundColor: "primary.main",
                              color: "white",
                              borderRadius: "50%",
                              minWidth: "20px",
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "0.75rem",
                            }}
                          >
                            {selectedInterests[area.id].length}
                          </Box>
                        )}
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          maxHeight: "400px",
                          overflowY: "auto",
                          "&::-webkit-scrollbar": { width: "4px" },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#bdbdbd",
                            borderRadius: "4px",
                          },
                        }}
                      >
                        {area.interests
                          .sort((a, b) => {
                            const aSelected = selectedInterests[
                              area.id
                            ]?.some((item) => item.id === a.id);
                            const bSelected = selectedInterests[
                              area.id
                            ]?.some((item) => item.id === b.id);
                            if (aSelected && !bSelected) return -1;
                            if (!aSelected && bSelected) return 1;
                            return 0;
                          })
                          .map((interest) => {
                            const isSelected =
                              selectedInterests[area.id]?.some(
                                (item) => item.id === interest.id
                              ) || false; // Add default false value
                            return (
                              <Box
                                key={interest.id}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  bgcolor: isSelected ? theme.palette.background.default : undefined,
                                  borderRadius: 1,
                                  padding: "4px",
                                  border: isSelected
                                    ? "1px solid rgba(246, 188, 188, 0.96)"
                                    : "1px solid transparent",
                                }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    cursor: "pointer",
                                  }}
                                >
                                  <Checkbox
                                    checked={isSelected}
                                    onChange={() =>
                                      handleInterestChange(area.id, interest)
                                    }
                                    sx={{
                                      color: isSelected
                                        ? "primary.main"
                                        : undefined,
                                    }}
                                  />
                                  <Typography
                                    variant="body1"
                                    color="textPrimary"
                                  >
                                    {interest.interest_name}
                                  </Typography>
                                </label>
                              </Box>
                            );
                          })}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  {/* it not show when the accordion is open */}
                  {expandedArea !== area.id &&
                    renderSelectedInterestsChips(area.id)}
                </React.Fragment>
              ))}

            {userCustomInterests.length > 0 && (
              <Box sx={{ px: 2, mt: 2, mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Custom interests
                </Typography>

                <Box display="flex" flexWrap="wrap" gap={1}>
                  {userCustomInterests.map((customInterest, index) => (
                    <Chip clickable={false}
                      onClick={() => { }}
                      key={index}
                      label={customInterest.interest_name}
                      variant="outlined"
                      color="primary"
                      size="small"
                      sx={{
                        bgcolor: "#f2ebe2",
                        color: "text.primary",
                      }}
                      onDelete={() =>
                        handleDeleteCustomInterest(customInterest.interest_name)
                      }
                    />
                  ))}
                </Box>
              </Box>
            )}

            <Typography variant="body2" color="textSecondary" sx={{ px: 2 }}>
              {" "}
              Can't find your interest?{" "}
              <Button
                disableElevation
                size="small"
                variant="text"
                color="primary"
                sx={{ textTransform: "none" }}
                onClick={handleOpenPopup}
              >
                Add a custom interest
              </Button>
            </Typography>

            <Dialog
              open={popupOpen}
              TransitionComponent={Transition}
              keepMounted
              role="dialog"
              aria-hidden={!open}
              maxWidth="xs"
              fullWidth
              aria-labelledby="dialog-title"
            >
              <IconButton
                aria-label="close"
                onClick={handleClosePopup}
                sx={{ position: "absolute", right: 10, top: 10 }}
              >
                <Close />
              </IconButton>

              <DialogTitle
                id="dialog-title"
                sx={{ bgcolor: "background.paper" }}
              >
                {"Add custom interest"}
              </DialogTitle>

              <DialogContent sx={{ bgcolor: "background.paper" }}>
                {success && (
                  <Typography
                    variant="body2"
                    color="success"
                    align="center"
                    sx={{ mb: 2 }}
                  >
                    {success}
                  </Typography>
                )}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Autocomplete
                    freeSolo
                    options={customInterestsList}
                    loading={isLoading}
                    value={customInterest}
                    onInputChange={(event, newValue) => {
                      setCustomInterest(newValue.replace(/[^a-zA-Z_ ]/g, ""));
                      setError(null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="outlined"
                        label="Custom interest"
                        placeholder="Type your interest (min 3 chars)..."
                        slotProps={{
                          htmlInput: {
                            ...params.inputProps,
                            maxLength: 25,
                          },
                          input: {
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {isLoading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                <InputAdornment
                                  position="end"
                                  sx={{ fontSize: 12 }}
                                >
                                  {customInterest.length}/25
                                </InputAdornment>
                              </>
                            ),
                          },
                        }}
                        error={Boolean(error)}
                        helperText={error}
                      />
                    )}
                  />

                  <Button
                    size="small"
                    disableElevation
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomInterest}
                    sx={{ textTransform: "none" }}
                    disabled={customInterest.trim().length < 3}
                  >
                    Add
                  </Button>
                </Box>
              </DialogContent>

              <DialogActions></DialogActions>
            </Dialog>
          </>
        ) : step === 4 && user?.account_type === "individual" ? (() => {
          const fromFestivalSubmissions = localStorage.getItem('fromFestivalSubmissions');
          return fromFestivalSubmissions === 'true' ? (
            <Box>
              <List dense>
                {[
                  "Freecomers helps festivals manage operations and improve reach with better efficiency",
                  "One place to manage submissions and festival operations",
                  "All-in-one dashboard for communication",
                  "Direct access to a growing filmmaker community",
                  "More focused outreach to optimize marketing spend",
                  "No exclusivity",
                  "We are onboarding a limited number of festivals",
                ].map((item, index) => (
                  <ListItem
                    key={index}>
                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                      <CheckCircleOutline color="primary" fontSize="small" />
                    </ListItemIcon>

                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        variant: "body1",
                        color: "text.secondary",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          ) : (
            <>
              {suggestedPeople.length === 0 && !isFetchingPeople && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 200,
                  }}
                >
                  <p>No people found</p>
                </Box>
              )}

              {isFetchingPeople ? (
                <List disablePadding>
                  {[...Array(10)].map((_, index) => (
                    <ListItem key={index} divider>
                      <ListItemAvatar>
                        <SkeletonAnimation
                          width={40}
                          height={40}
                          animation="wave"
                          variant="circular"
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <SkeletonAnimation
                            animation="wave"
                            variant={"text"}
                            height={30}
                          />
                        }
                        secondary={<SkeletonAnimation animation="wave" />}
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <List>
                  {suggestedPeople.map((person) => (
                    <ListItem
                      disableGutters
                      key={person.id}
                      divider
                      secondaryAction={
                        // <Button
                        //   variant="outlined"
                        //   onClick={() => handleFollowToggle(person.id)}
                        //   sx={{
                        //     textTransform: "none",
                        //     padding: "4px 8px",
                        //     fontSize: "0.8rem",
                        //     "& .MuiButton-startIcon": {
                        //       mr: 0.5,
                        //     },
                        //   }}
                        //   size="small"
                        //   color={
                        //     followedPeople.includes(person.id)
                        //       ? "inherit"
                        //       : "primary"
                        //   }
                        //   startIcon={
                        //     followedPeople.includes(person.id) ? (
                        //       <Close sx={{ fontSize: "0.8rem" }} />
                        //     ) : (
                        //       <Add sx={{ fontSize: "0.8rem" }} />
                        //     )
                        //   }
                        // >
                        //   {followedPeople.includes(person.id)
                        //     ? "Cancel"
                        //     : "Connect"}
                        // </Button>

                        <Button
                          variant="outlined"
                          onClick={() => handleFollowToggle(person.id, person.account_type)}
                          sx={{
                            textTransform: "none",
                            padding: "4px 8px",
                            fontSize: "0.8rem",
                            "& .MuiButton-startIcon": {
                              mr: 0.5,
                            },
                          }}
                          size="small"
                          color={
                            followedPeople.includes(person.id) ? "inherit" : "primary"
                          }
                          startIcon={
                            followedPeople.includes(person.id) ? (
                              <Close sx={{ fontSize: "0.8rem" }} />
                            ) : (
                              <Add sx={{ fontSize: "0.8rem" }} />
                            )
                          }
                        >
                          {followedPeople.includes(person.id)
                            ? person.account_type === "organization"
                              ? "Unfollow"
                              : "Cancel"
                            : person.account_type === "organization"
                              ? "Follow"
                              : "Connect"}
                        </Button>

                      }
                    >
                      <ListItemAvatar sx={{ minWidth: 45 }}>
                        <Avatar
                          sx={{ width: 34, height: 34 }}
                          src={getImageUrlWithToken(person.thumbnail_pic)}
                          alt={person.name}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          person.name.length > 16
                            ? person.name.substring(0, 16) + "..."
                            : person.name
                        }
                        secondary={person.describes_me}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </>
          );
        })() : step === 4 && user?.account_type === "organization" ? (
          <Box>
            <List dense>
              {[
                "Freecomers helps festivals manage operations and improve reach with better efficiency",
                "One place to manage submissions and festival operations",
                "All-in-one dashboard for communication",
                "Direct access to a growing filmmaker community",
                "More focused outreach to optimize marketing spend",
                "No exclusivity",
                "We are onboarding a limited number of festivals",
              ].map((item, index) => (
                <ListItem
                  key={index}
  >
                  <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                    <CheckCircleOutline color="primary" fontSize="small" />
                  </ListItemIcon>

                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      variant: "body1",
                      color: "text.secondary",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ bgcolor: "background.paper", p: 2 }}>

        {step === 1 && (
          <Button
            fullWidth
            variant="contained"
            disableElevation
            sx={{ textTransform: "none" }}
            onClick={handleGetStarted}
          >
            Get Started
          </Button>
        )}

        {step === 3 && (
          <Button
            fullWidth
            variant="contained"
            disableElevation
            onClick={handleUpdateInterests}
            disabled={
              Object.values(selectedInterests).flat().length === 0
            }
            sx={{ textTransform: "none" }}
          >
            Continue
          </Button>
        )}

        {step === 4 && user?.account_type === "individual" && (() => {
          const fromFestivalSubmissions = localStorage.getItem('fromFestivalSubmissions');
          return fromFestivalSubmissions === 'true' ? (
            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{ textTransform: "none" }}
              onClick={handleJoinWaitlist}
            >
              Join Waitlist
            </Button>
          ) : (
            <Button
              sx={{
                textTransform: "none",
              }}
              variant="contained"
              size="small"
              disableElevation
              onClick={() => {
                // Clear festival listing and submissions flags after completing onboarding
                localStorage.removeItem('fromFestivalListing');
                localStorage.removeItem('fromFestivalSubmissions');
                localStorage.removeItem('onboarding_step');
                setOpen(false);
                onAllDone();
              }}
            >
              {changeBtnText}
            </Button>
          );
        })()}

        {step === 4 && user?.account_type === "organization" && (
          <Button
            fullWidth
            variant="contained"
            disableElevation
            sx={{ textTransform: "none" }}
            onClick={handleJoinWaitlist}
          >
            Join Waitlist
          </Button>
        )}

      </DialogActions>

    </Dialog>
  );
};

export default InterestsDialog;
